module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Mono-Bold-9b7ee0371a824fabf5eb454fae1b160a.eot";